export default __webpack_public_path__ + "static/agentic-ai-studio-theloops-ccf65ed4dbfd0dde2627ac3717c01401.jpg";